import React from 'react';
import { PinnacleSearchFieldProps } from './PinnacleSearchField.types';
import StyledSearchField from './PinnacleSearchField.styled';

const PinnacleSearchField: React.FC<PinnacleSearchFieldProps> = (props) => {
  return <StyledSearchField {...props} />;
};

export default PinnacleSearchField;
